module.exports = __webpack_public_path__ + "static/media/bg-shorten-mobile.4a7a7f61.svg";